<script>
import vue2Dropzone from "vue2-dropzone";
import GiftApi from "@/services/gift-api";

export default {
  components: { vue2Dropzone },
  
  props : {
        campaign:{
          type:Object,
          default:() => null,
      },
    },

  data() {
    return {

        giftCampaign:{id:null, isWithGift:false, uniqueGift:false},

        start:null,
        end:null,
        showCadeauModal: false,
        gift:   {id:null, name:null, type:null, image:null, minAmountOrder:null, changeToWin:null , period:null , thresholdGift:null , countItemsConcerned:null ,itemSectionIds:null , startDate:null , endDate:null, percent:null, amount:null ,isActive: null},

        dropzoneOptions: {
            url: "/",
            addRemoveLinks: true,
            autoProcessQueue:false,
            maxFiles: 1,
            },
        maxSize : null ,
        //TODO PHYSICAL only
        giftType:0,
        promoType:null,
        //TODO CAMPAIGN only
        giftCondition:1,
        itemsConcerned:null,
        sectionList:null,
        pagemodel: { currentPage: 1, perPage: 10, totalRows: 0 },
        giftList: null,
        isTableLoading: false,
        percentIsEditable: false,
        minAmountOrderIsEditable: false,
        changeToWinIsEditable: false,
        amountIsEditable: false,
        vSelectKey:0,
        giftFields: [
                {key: "id",label: "ID",thClass: "text-left",tdClass: "text-left align-middle",},

                {key: "timeStamp",label: "Date", sortable: false,tdClass: "font-weight-bold align-middle",thClass: "text-left"},
                {key: "name",label: "Titre",thClass: "text-left",tdClass: " align-middle font-weight-bold",thStyle: "", tdStyle: "",},
                {key: "thresholdGift",label: "Limite ",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "numberGiftsRemaining",label: "Cadeaux restants",thClass: "text-left",tdClass: "text-left align-middle",},
                {key: "validationDate", label: "Dates de validité", thClass: "text-left",tdClass: " align-middle",},
                {key: "isActive",label: "Actif",thClass: "text-center",tdClass: "text-center align-middle",},
                {key: "action", label: "", thClass: "", tdClass: " align-middle" },
            ],




    }

  },
  mounted(){
    if(this.giftCampaign.id){
        this.getAllGift();
    }
  },

  watch:{

    campaign: function(){
        if(this.campaign){
        this.giftCampaign = this.campaign
        this.getAllGift()
        }
    },

    start : function(){
        this.getAllGift()
    },
    end : function(){
        this.getAllGift()
    },


    'giftCampaign.isWithGift': function(){
        this.setIsCampaignWithGift()
    },

  },

  computed:{
    itemSectionIdList(){
        if(!this.gift.itemSectionIds){
            return
        }
        return this.gift.itemSectionIds.map(section => section.id);
        },

  },
  methods:{

    setIsCampaignWithGift() {

        if(this.giftCampaign == null || this.giftCampaign.isWithGift == null){
            return
        }

        GiftApi.setIsCampaignWithGift(this.giftCampaign.isWithGift, this.giftCampaign.id )
            .then((result) => {
                if (result) {
                    this.$store.dispatch("menu/setStateFromCampaign", result);
                }
            })
    },

    removeImage(giftId){
        GiftApi.removeGiftImage(giftId).then((result)=>{
            if(result){
                this.gift.image = null
            }
        })

    },

    getAllitemSectionKeys(itemSectionIds) {
        if (!this.sectionList || !Array.isArray(itemSectionIds)) {
            return [];
        }
        
        return this.sectionList.filter(item => itemSectionIds.includes(item.id));
    },

    openCadeau(){
        this.gift= {}
        this.gift=   {id:null, name:null, type:null, image:null, minAmountOrder:null, changeToWin:null , period:null , thresholdGift:null , countItemsConcerned:null ,itemSectionIds:null , startDate:null , endDate:null, percent:null, amount:null, isActive: null},
        //TODO CAMPAIGN only
        this.giftCondition = 1,
        this.giftType = null,
        this.itemsConcerned = null,
        this.promoType = null,
        this.showCadeauModal = true
    },
    editGift(gift){
        this.gift = gift
        this.promoType = gift.amount ? 1 : this.gift.percent  ? 0 : null
        this.gift.itemSectionIds = this.getAllitemSectionKeys(gift.itemSectionId)
        this.giftCondition =gift.giftCondition
        this.itemsConcerned=gift.itemsConcerned
        this.giftType=gift.giftType
        this.percentIsEditable= false,
        this.amountIsEditable= false,
        this.minAmountOrderIsEditable= false,
        this.changeToWinIsEditable=false,
        this.showCadeauModal = true
    },

    
    getAllGift() {
        this.isTableLoading = true;
        GiftApi.getAllGift( this.pagemodel.currentPage, this.pagemodel.perPage, this.start , this.end, this.giftCampaign.id )
            .then((giftList) => {
            if (giftList) {
                this.giftList = giftList.list;
                this.pagemodel.totalRows = giftList.total;
                this.pagemodel.currentPage = giftList.page;
                this.pagemodel.perPage = giftList.pageSize;
                this.pagemodel.pageSize = giftList.pageSize;
            }
            })
            .finally(() => {
            this.isTableLoading = false;
            });
    },

    activeGift(){
        if (this.gift && this.gift.id) {
            this.addGift()
        }
    },

    addGift(){
        const formData = new FormData();
         const image=this.$refs.myVueDropzone.getAcceptedFiles()[0]
         if (image) {
            formData.append('image', image);
        }

         if (this.gift && this.gift.id) {
            formData.append('id', this.gift.id);
        }

        if (this.gift && this.gift.name) {
            formData.append('name', this.gift.name);
        }

        if (this.gift && this.gift.startDate) {
            formData.append('startDate', this.gift.startDate);
        }

        if (this.gift && this.gift.endDate) {
            formData.append('endDate', this.gift.endDate);
        }

        if (this.giftType != null) {
            formData.append('giftType', this.giftType);
        }

        if (this.gift && this.gift.percent && this.promoType == 0) {
            formData.append('percent', this.gift.percent);
        }

        if (this.gift && this.gift.amount && this.promoType == 1) {
            formData.append('amount', this.gift.amount);
        }

        if (this.gift && this.gift.isActive ) {
            formData.append('isActive', this.gift.isActive);
        }

        if (this.itemSectionIdList && this.itemSectionIdList.length) {
            formData.append('itemSectionIds', this.itemSectionIdList);
        }
        if (this.giftCondition != null ) {
            formData.append('giftCondition', this.giftCondition);
        }

        if (this.itemsConcerned != null) {
            formData.append('itemsConcerned', this.itemsConcerned);
        }

        if (this.gift && this.gift.countItemsConcerned) {
            formData.append('countItemsConcerned', this.gift.countItemsConcerned);
        }

        if (this.gift && this.gift.thresholdGift) {
            formData.append('thresholdGift', this.gift.thresholdGift);
        }

        if (this.gift && this.gift.period) {
            formData.append('period', this.gift.period);
        }

        if (this.gift && this.gift.minAmountOrder && this.giftCondition == 1) {
            formData.append('minAmountOrder', this.gift.minAmountOrder);
        }

        if (this.gift && this.gift.changeToWin && this.giftCondition == 1) {
            formData.append('changeToWin', this.gift.changeToWin);
        } 

        if (this.giftCampaign && this.giftCampaign.id) {
            formData.append('campaignId', this.giftCampaign.id);
        } 
        
        GiftApi.addGift(formData, this.pagemodel.currentPage,this.pagemodel.perPage,)
        .then((giftList) => {
        if (giftList) {
            this.isTableLoading = true;

            this.giftList = giftList.list;
            this.pagemodel.totalRows = giftList.total;
            this.pagemodel.currentPage = giftList.page;
            this.pagemodel.perPage = giftList.pageSize;
            this.pagemodel.pageSize = giftList.pageSize;
            this.showCadeauModal = false
            this.isTableLoading = false;

        }
        })
        .finally(() => {
        this.isTableLoading = false;
        });
    }
  }

};
</script>
<template>
    <div >
            <div class="row">
                <div class="col-md-8 col-12">
                    <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">{{$t('gift.giftTitle')}}  </h2>
                </div>

               

                <div class="col-lg-12 col-md-12 col-12 mt-3" >
                    <b-form-checkbox switch variant="primary"
                        :value="true" id="enable-gift-check-box"
                        :unchecked-value="false"
                        v-model="giftCampaign.isWithGift"
                        class="custom-checkbox custom-checkbox-primary mb-0 mt-0 font-size-16"
                        @click="setIsCampaignWithGift()">

                        <label class="ml-1 mb-0 font-size-16"
                  :class="giftCampaign.isWithGift? 'text-primary font-weight-bold' : 'text-info'"
                  for="enable-gift-check-box" style="cursor: pointer">
                  {{ $t("campaign.campaignWithGift") }}
                  </label>
                       
                    </b-form-checkbox>

                

                  
                </div>

            </div>
            
            <b-button
                variant="outline-dark"
                class="float-right mb-5 mt-4  ml-3 mt-2"
                @click="openCadeau()" >
                <i
                  class="fas fa-plus font-size-16 m-0 p-0 align-middle mr-2"
                ></i>
                <span class="font-weight-bold text-uppercase"
                  >{{ $t("gift.newButton") }}
                </span>
              </b-button>
        <div class="table-responsive" style="min-height: 27em;">

              
            <b-table
                :busy="isTableLoading"
                :striped="true"
                :small="false"
                :hover="true"
                :items="giftList"
                :fields="giftFields"
                :perPage="pagemodel.perPage"
                class="table mt-3"
                style="min-width: 1360px;"
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                <template v-slot:cell(validationDate)="{ item }">
                    <div  > 
                        <div v-if="item.startDateStr"  class="font-italic text-dark font-size-12 " > Du  <strong>{{ item.startDateStr }}</strong>  </div>
                        <div v-if="item.endDateStr"  class="font-italic text-dark font-size-12 " > Au <strong>{{ item.endDateStr }}</strong>  </div>

                    </div>
                </template>
                <template v-slot:cell(isActive)="{value}">
                    <i :class="value ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>

                <template v-slot:cell(countItemsConcerned)="{ value }">
                        <span  class="font-size-12 " >{{ value ? value : '-' }} </span>
                </template>
                <template v-slot:cell(giftType)="{ item }">
                    <b-badge v-if="item.giftType==0"  href="#" class="font-size-12" variant="danger">Physique</b-badge>
                    <b-badge  v-else class="font-size-12"  variant="light">Code Promotion</b-badge>

                </template>

                <template v-slot:cell(promoAmont)="{ item }">
                    <span>{{  (item.amountAsString ? item.amountAsString : item.percentAsString ? item.percentAsString : '-' ) }}</span>

                </template>

                <template v-slot:cell(minAmountOrder)="{ item }">
                    <span>{{  (item.minAmountOrder ? item.minAmountOrderAsString : '-' ) }}</span>

                </template>

                <template v-slot:cell(giftCondition)="{ value }">
                    <b-badge v-if="value==0"  href="#" class="font-size-12" variant="info">Clique sur article </b-badge>
                    <b-badge v-else  href="#" class="font-size-12"  variant="success">Commande par CB</b-badge>

                </template>

                <template v-slot:cell(itemSectionId)="{ item }">
                    <div v-if="item.itemSectionId && item.itemSectionId.length ">
                            <span v-for="itemSection in getAllitemSectionKeys(item.itemSectionId)" :key="itemSection.id">
                            <span class="badge font-size-10 pt-1 m-1 " style="outline: 1px solid grey;"> {{itemSection.name}} </span>
                        </span> 
                    </div>
                    <div v-else-if="item.itemsConcerned == 0">
                        <span class="badge font-size-10 pt-1 m-1 " style="outline: 1px solid grey;"> 
                            Tout le Catalogue </span>
                    </div>
                    <div v-else>-</div>


                </template>

                <template v-slot:cell(thresholdGift)="{ item }">
                    <div class="my-2">
                        {{ item.thresholdGift }} / {{ item.period }} Jours
                    </div>
                </template>

                <template v-slot:cell(numberGiftsRemaining)="{ item,value }">
                    <div class="text-dark mb-2"><strong>{{value}}</strong> cadeaux restants</div>
                   
                    <div v-if="item.periodStartDate"  class="font-italic text-dark font-size-12 " > du  <strong>{{ item.periodStartDate }}</strong>  </div>
                    <div v-if="item.periodEndDate"  class="font-italic text-dark font-size-12 " > au <strong>{{ item.periodEndDate }}</strong>  </div>

                </template>


                

                <template v-slot:cell(action)="{ item }">
                    <img  class="icontrash ml-2" alt="" src="@/assets/icons/edit.svg"  @click="editGift(item)" height="17"  style="cursor: pointer;"/>
                </template>

            </b-table>
        
            <span v-if="!isTableLoading && giftList && !giftList.length" class="d-flex justify-content-center m-4 text-danger">
             {{ $t("gift.emptyGift") }}
            </span>
        </div>
             <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getAllGift()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,20]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getAllGift()" :disabled="isTableLoading" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 

      <b-modal
        v-model="showCadeauModal"
        :title="gift && gift.id ?  $t('gift.modal.update') : $t('gift.modal.title') " 
        hide-footer
        centered
        title-class="text-primary text-uppercase font-size-16"
        title-tag="h5"
        header-close-variant="danger"
        size="xl"

        no-close-on-esc   
        no-close-on-backdrop  
        >

        <div class="row">

            <div class="col-12 col-lg-7 pr-lg-3">       
                <b-form-group class="m-0">
                    <b-form-checkbox v-model="gift.isActive" switch class="float-md-left" @input="activeGift()">
                        <label :class="gift.isActive ? 'text-primary' : 'text-muted'">{{ gift.isActive ?  $t('gift.active') : $t('gift.inActive') }}</label>
                    </b-form-checkbox>
                </b-form-group>
                       
                <b-form-group  class="text-primary font-weight-bold text-uppercase mt-4" :label="$t('gift.modal.input.label.name')">
                    <b-form-input v-model="gift.name" :placeholder="$t('gift.modal.input.placeholder.name')" ></b-form-input>
                </b-form-group>

                <div class="text-primary text-uppercase font-weight-bold mb-3 mt-4">Dates de validité</div>       

                <div class="row">
                    <div class="col-12 col-md-6 pr-md-2 text-center " >
                        <b-form-group   label-for="">
                            <b-form-datepicker
                            v-model="gift.startDate"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button size="sm"
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright
                            hide-header
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>

                    <div class="col-12 col-md-6 pl-md-2 text-center " >
                        <b-form-group label-for="">
                            <b-form-datepicker
                            v-model="gift.endDate"
                            :locale="$t('datPicker.locale')"
                            :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                            dark
                            reset-button
                            close-button
                            :label-reset-button="$t('datPicker.label-reset-button')"
                            :label-close-button="$t('datPicker.label-close-button')"
                            dropright                         
                            hide-header size="sm"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            ></b-form-datepicker>
                        </b-form-group>
                    </div>

                </div>

                <!-- <div class="text-primary text-uppercase font-weight-bold mb-3 mt-4">Type de cadeau</div>       

                <div  class="row ml-4">
                    <div class="col-5">
                        <b-form-radio
                            class="custom-radio custom-radio custom-radio-primary mb-3"
                            value="0"
                            v-model="giftType"><span :class="giftType != 0 ? '' : 'text-primary font-weight-bold'">Physique</span>
                        </b-form-radio> 
                    </div>   

                    <div class="col-7">
                        <b-form-radio
                            class="custom-radio custom-radio custom-radio-primary mb-3"
                            value="1"
                            v-model="giftType"><span :class="giftType != 1 ? '' : 'text-primary font-weight-bold'">Code Promotion</span>
                        </b-form-radio> 
                    </div>
                </div>

                <div v-if="giftType == 1" class="text-primary text-uppercase font-weight-bold mb-3 mt-4">Type de Carte Promotion</div>       


                <div class="ml-4" v-if="giftType == 1" >
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <b-form-radio
                                class="custom-radio custom-radio custom-radio-primary mb-3"
                                value="0"
                                v-model="promoType"><span :class="promoType != 0 ? '' : 'text-primary font-weight-bold'">Pourcentage</span>
                            </b-form-radio> 
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <b-form-group  class="text-dark" :style="promoType != 0 ? 'opacity:0.5': ''"  :disabled="promoType != 0">
                                <b-form-input v-model="gift.percent" type="number" :placeholder="$t('gift.modal.input.placeholder.promoTypePercente')" ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <b-form-radio
                                class="custom-radio custom-radio custom-radio-primary mb-3"
                                value="1"
                                v-model="promoType"><span :class="promoType != 1 ? '' : 'text-primary font-weight-bold'">Montant</span>
                            </b-form-radio> 
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <b-form-group  class="text-dark" :style="promoType != 1 ? 'opacity:0.5': ''" :disabled="promoType != 1">
                                <b-form-input v-model="gift.amount" type="number" :placeholder="$t('gift.modal.input.placeholder.promoTypeAmount')" ></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    
                </div>

                <div class="text-primary text-uppercase font-weight-bold mb-3 mt-4">Condition de Cadeau</div>       

                <div  class="row ml-4">
                    <div class="col-lg-5 col-md-12 ">
                        <b-form-radio
                            class="custom-radio custom-radio custom-radio-primary mb-3"
                            value="0"
                            v-model="giftCondition"><span :class="giftCondition != 0 ? '' : 'text-primary font-weight-bold'">Clique sur article</span>
                        </b-form-radio> 
                    </div>   

                    <div class="col-lg-7 col-md-12 ">
                        <b-form-radio
                            class="custom-radio custom-radio custom-radio-primary mb-3"
                            value="1"
                            v-model="giftCondition"><span :class="giftCondition != 1 ? '' : 'text-primary font-weight-bold'">Commande par carte bancaire</span>
                        </b-form-radio> 
                    </div>
                </div> -->

                <!-- <div v-if="giftCondition != null">

                    <hr style="width:80%;" class="mb-3"/>

                    <div v-if="giftCondition == 0" >

                        <b-form-radio
                            class="custom-radio custom-radio custom-radio-primary mb-3"
                            value="0"
                            v-model="itemsConcerned"><span :class="itemsConcerned != 0 ? '' : 'text-primary font-weight-bold'">Tout le catalogue</span>
                        </b-form-radio> 

                        <div class="row ">
                            <div class="col-lg-6 col-md-12">
                                <b-form-radio
                                    class="custom-radio custom-radio custom-radio-primary mb-3"
                                    value="1"
                                    v-model="itemsConcerned"><span :class="itemsConcerned != 1 ? '' : 'text-primary font-weight-bold'">Rayon</span>
                                </b-form-radio> 
                            </div>
                            <div class="col-lg-6 col-md-12 mb-2 mb-lg-0">
                                <div v-if="sectionList">
                                <v-select :key="vSelectKey"  
                                    class=" font-weight-bold " 
                                    size="sm" 
                                    :multiple="true"
                                    :disabled="itemsConcerned != 1"
                                    v-model="gift.itemSectionIds" 
                                    :options="sectionList"  
                                    style="font-size:12px; border-radius: 5px; " 
                                    placeholder="Sélectionner la Section" 
                                    label="name"
                                    @input="vSelectKey ++ "
                                     >
                                    <span slot="no-options">Aucun élément dans la liste</span>
                                
                                </v-select> 
                                </div>
                            </div>


                        </div>

                       

                        <b-form-group  class="text-dark" :label="$t('gift.modal.input.label.itemCount')">
                            <b-form-input v-model="gift.countItemsConcerned" type="number" :placeholder="$t('gift.modal.input.placeholder.itemCount')" ></b-form-input>
                        </b-form-group>

                    
                    </div>
                    <div v-else > 

                        <b-form-group   class="text-dark" :label="$t('gift.modal.input.label.amontMinOrder')">
                            <b-form-input v-model="gift.minAmountOrder" type="number" :placeholder="$t('gift.modal.input.placeholder.amontMinOrder')" ></b-form-input>
                        </b-form-group>-->

                   
                        <div class="text-primary text-uppercase font-weight-bold mb-2 mt-4">{{$t('gift.modal.input.label.chanceToWin')}}</div>       
                        <b-form-group class="text-dark" >
                            <b-form-input v-model="gift.changeToWin" type="number" :placeholder="$t('gift.modal.input.placeholder.chanceToWin')" ></b-form-input>
                       </b-form-group>

                    <!-- </div> -->



                    <!-- <hr style="width:80%;" class="mt-3 mb-3"/> -->

                <!-- </div> -->

                <div class="text-primary text-uppercase font-weight-bold mb-3 mt-4">Limite des cadeaux par période</div>       


                <div class="row mt-3" >
                    <div class="col-lg-6 col-md-12 pr-md-2">
                        <b-form-group  class="text-dark " :label="$t('gift.modal.input.label.limitToWin')">
                            <b-form-input v-model="gift.thresholdGift" type="number" :placeholder="$t('gift.modal.input.placeholder.limitToWin')" ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <b-form-group  class="text-dark " :label="$t('gift.modal.input.label.periode')">
                                <b-form-input v-model="gift.period" type="number" :placeholder="$t('gift.modal.input.placeholder.periode')" ></b-form-input>
                        </b-form-group>
                    </div>
                </div>



            </div>     
            <div class="col-lg-5 col-md-12 col-12">
                <div v-if="gift && gift.image" > Image
                    <img  class="ml-2" width="25px" alt="" src="@/assets/icons/trash.svg" @click="removeImage(gift.id)" style="cursor: pointer;" />

                     </div>              

                <img  v-if="gift && gift.image" class="mt-2 mb-2" :src="'/api/image/get/'+ gift.image" width="100%" height="auto" />

                <b-form-group class="text-dark" label="Image (PNG, JPEG)" label-for="">
                    <vue2Dropzone class="m-0 p-0 m-md-1 p-md-1" id="dropzone" ref="myVueDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                        <div class="dropzone-custom-content text-center">
                            <img   alt=""  width="80px" class="mb-4" src="@/assets/icons/fi-rr-cloud-upload.svg"  />  
                            <h5 class="mb-0 ">{{$t('parameters.dropImage')}}</h5>
                            <h6 class="text-primary font-size-9 text-Center mt-1" >{{$t('parameters.imageSize')}} {{ this.maxSize}} </h6>
                        </div>
                    </vue2Dropzone>
                </b-form-group>     
            </div>

        </div>

    
        <div class="row m-0">
            <div class="col-lg-8 col-md-12 col-sm-0"></div>
            <div class="col-lg-4 col-md-12 col-sm-12">
                <b-button
                variant="outline-dark"
                class="getStarted1 font-size-14 btn-block mt-2 mb-2 w-100 sm"
                @click="addGift()">
                    {{ gift && gift.id ?  $t('gift.modal.savegift.updateButtonText') : $t('gift.modal.savegift.saveButtonText') }}
                </b-button>
            </div>


        </div>
        
       

    </b-modal>
    </div>
</template>

